import script from "./EducationEditView.vue?vue&type=script&lang=ts&setup=true"
export * from "./EducationEditView.vue?vue&type=script&lang=ts&setup=true"

import "./EducationEditView.vue?vue&type=style&index=0&id=739efefb&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-739efefb"]])

export default __exports__